import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';

class RadioButtons extends PreLoginPage {
  constructor() {
    super();
    this.state = {
      selectedOption: ''
    };
  //this.radioChange = this.radioChange.bind(this);
}

  radioChange(e) {
    if(typeof this.props.callBack === "function"){
      this.props.callBack(e);
    }

    console.log("radioChange")
      console.log(e.target.value," ", e.value)
    this.setState({
      selectedOption: e.target.value
    });
  }
  
  render() {
    return (
        <div>
          <div className="col-md-2 radio-group">
              <span className="radio-button">
              <input type="radio"
                  value="Yes"
                  checked={this.state.selectedOption === "Yes"}
                  onChange={this.radioChange.bind(this)}/>
                  <label className="radio-label"> Yes</label>
              </span>
            </div>
            <div className="col-md-2 radio-group">
              <span className="radio-button">
              <input type="radio"
                  value="No"
                  checked={this.state.selectedOption === "No"}
                  onChange={this.radioChange.bind(this)}/>
                  <label className="radio-label"> No</label>
              </span>
            </div>
        </div>



    );
  }
}
export default RadioButtons;


// WEBPACK FOOTER //
// ./src/views/login/RadioButtons.js